/**
 * Date Range Filter Chip
 * Story 4.3: AC-4.3.4 - Filter shows as removable chip
 */
import React from 'react';
import { IconX } from './icons';
import { formatDateRangeChip } from '../utils/dateRangeFilter';
import type { DateRangeFilter, GridColumn } from '../types/gridTypes';

interface DateRangeChipProps {
  filter: DateRangeFilter;
  columns: GridColumn[];
  onRemove: () => void;
}

export function DateRangeChip({ filter, columns, onRemove }: DateRangeChipProps) {
  const column = columns.find(c => c.id === filter.fieldId);
  const fieldLabel = column?.label || filter.fieldId;
  const rangeLabel = formatDateRangeChip(filter);

  return (
    <div className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
      <span className="font-medium">{fieldLabel}:</span>
      <span>{rangeLabel}</span>
      <button
        onClick={onRemove}
        className="ml-1 p-0.5 hover:bg-blue-200 rounded-full"
        aria-label="Remove date range filter"
      >
        <IconX className="w-3 h-3" />
      </button>
    </div>
  );
}
